import { UntypedFormGroup } from '@angular/forms';
import { StepCssClass } from '@clux-models';
import { IStep, StepViewModel, TeardownResult } from './stepViewModel';

export class Step<S> implements IStep<S> {
  public valid = true;
  public visitable = false;
  public isSavedToEntity = false;
  public stepCssClass = StepCssClass.Default;
  public substep = 0; // used by child classes if a single step is comprised of multiple views
  public numSubsteps = 0;
  public form: UntypedFormGroup;

  constructor(public step?: S) {}

  public initialize(_parent?: StepViewModel<S, unknown>): void | S {}

  public teardown(_parent?: StepViewModel<S, unknown>): Promise<void | S | TeardownResult> | void | S | TeardownResult {}
}
